import { cartFulfillmentMethodStyles } from "@insite/content-library/Widgets/Cart/CartFulfillmentMethodSelector";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import { COLORS, TYPOGRAPHY } from "@store/theme/common/design";
import { checkoutBlockTitleStyles } from "@store/theme/common/mixins";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import { css } from "styled-components";

Object.assign(cartFulfillmentMethodStyles, {
    fulfillmentMethodradioGroup: {
        css: css`
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [
                        { values: ["100%", null, "50%", null, null], properties: ["width"] },
                        { values: ["30px", null, "0", null, null], properties: ["margin-bottom"] },
                    ],
                    mediaOptions.min,
                )}

            ${TypographyStyle} {
                color: ${COLORS.text.dark};
            }

            legend {
                ${checkoutBlockTitleStyles()}
                margin-bottom: 20px !important;
            }
        `,
    },
    pickUpLocation: {
        wrapper: {
            css: css`
                ${({ theme }) =>
                    breakpointValuesMediaQueries(
                        theme,
                        [{ values: ["100%", null, "50%", null, null], properties: ["width"] }],
                        mediaOptions.min,
                    )}
            `,
        },
        headerText: {
            css: css`
                ${checkoutBlockTitleStyles()}
            `,
        },
        changeLink: {
            css: css`
                margin-left: 15px;
            `,
        },
        warehouseAddress: {
            wrapper: {
                css: css`
                    margin-top: 20px;
                `,
            },
            nameText: {
                as: "p",
                css: css`
                    font-size: ${TYPOGRAPHY.size.small};
                    color: ${COLORS.text.dark} !important;
                `,
            },
        },
    },
});
